/*
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-02-03 15:34:02
 * @LastEditors  : Archer<ahh666@qq.com>
 * @LastEditTime : 2023-02-03 16:06:03
 * @FilePath     : \youxi\src\components\LeaveMsg\index.js
 * @Description  : Description
 */
import Vue from "vue";
import LeaveMsgTemp from "./index.jsx";

let queue = [];

const instance = () => {
  const leaveMsg = new (Vue.extend(LeaveMsgTemp))({
    el: document.createElement("div")
  });
  return leaveMsg.$el;
};

const LeaveMsg = () => {
  const comp = instance();
  document.body.appendChild(comp);
  queue.push(comp);
  queue.length > 1 && document.body.removeChild(queue[0]) && queue.shift();
};

LeaveMsg.install = () => {
  Vue.prototype.$leaveMsg = LeaveMsg;
};

export default LeaveMsg;
